import { FunctionComponent } from 'react';
import styles from './FinalResults.module.scss';
import { Label } from 'components/UI/V3/Forms/Label/Label';
import { Radio } from 'components/UI/V3/Forms/Radio/Radio';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faScissors, faBan, faHotel } from '@fortawesome/pro-regular-svg-icons';
import { EvaluationReport } from '@spike/report-model';

export interface FinalResultsProps {
    evaluationReport: EvaluationReport;
    /** Evaluation categories configured for the service; only these are shown. */
    categories: Array<string>;
    onChange: (field: keyof EvaluationReport, value: string) => void;
}

export const FINAL_RESULTS_CONFIG: {
    key: keyof EvaluationReport;
    label: string;
    icon: any;
    category: string;
}[] = [
    { key: 'finalResultGrooming', label: 'Grooming', icon: faScissors, category: 'grooming' },
    { key: 'finalResultDaycare', label: 'Daycare', icon: faBan, category: 'daycare' },
    { key: 'finalResultBoarding', label: 'Boarding', icon: faHotel, category: 'boarding' }
];

export const FinalResults: FunctionComponent<FinalResultsProps> = props => {
    const configuredResults = FINAL_RESULTS_CONFIG.filter(({ category }) => props.categories.includes(category));

    return (
        <div className={styles.container}>
            <Label className={styles.sectionLabel}>Final Results</Label>
            <div className={styles.results}>
                {configuredResults.map(({ key, label, icon }) => (
                    <div
                        key={key}
                        className={styles.resultItem}
                    >
                        <div className={styles.resultInfo}>
                            <FontAwesomeIcon
                                icon={icon}
                                size="sm"
                                className={styles.icon}
                            />
                            <Label className={styles.resultLabel}>{label}</Label>
                        </div>
                        <div className={styles.radioGroup}>
                            <Radio
                                inlineLabel="Pass"
                                checked={props.evaluationReport[key] === 'pass'}
                                onChange={() => props.onChange(key, 'pass')}
                                className={styles.radioOption}
                            />
                            <Radio
                                inlineLabel="Fail"
                                checked={props.evaluationReport[key] === 'fail'}
                                onChange={() => props.onChange(key, 'fail')}
                                className={styles.radioOption}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
